mtl.alloy.factory['smooth-scroll'] = (function($, app, util) {
    'use strict';

    var $smoothScrollTimeout = null;

    return function(element, options) {

        $(element).on('click', smoothScroll);

        //On page load, smooth scroll to panel
        var hash = window.location.hash.replace('panel-', '');
        if (hash && !$('body').hasClass('hash-visited')) {
            canProceed(hash);
        }

        $('body').addClass('hash-visited');

    };

    function canProceed(hash)
    {
        var $proceed = false;

        var $readMoreLength = $("[data-init='read-more']").length;
        var $shrunkReadMoreLength = 0;

        $("[data-init='read-more']").each(function(){
            if($(this).hasClass('shrunk'))
                $shrunkReadMoreLength++;
        });

        if($shrunkReadMoreLength == $readMoreLength)
            $proceed = true;

        clearTimeout($smoothScrollTimeout);

        if(!$proceed)
        {
            $smoothScrollTimeout = setTimeout(function(){ canProceed(hash); }, 1000);
        } else {
            $('a[href="'+hash+'"]').click();
        }
    }

    function smoothScroll(e)
    {
        e.preventDefault();

        var target = this.hash;
        var $target = $(target);

        $('html, body').stop().animate({
            'scrollTop': $target.offset().top - $('.layout-header').height()
        }, 900, 'swing', function () {
            //window.location.hash = 'panel-' + target.replace('#', '');
        });
    }

}(jQuery, app, util));
